import { useEffect, useState } from 'react';
import { useI18n } from '../i18n';
import { HERO_SLIDES, STORE_URL } from '../constants';

export const Hero = () => {
  const { t } = useI18n();
  // JS-driven crossfade: a timer advances the active slide. Unlike a CSS keyframe
  // animation, this keeps cycling on iOS Low Power Mode (where CSS animations are
  // disabled and the slides would otherwise never appear).
  const [active, setActive] = useState(0);
  useEffect(() => {
    if (HERO_SLIDES.length < 2) return;
    const id = window.setInterval(() => {
      setActive((i) => (i + 1) % HERO_SLIDES.length);
    }, 6000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <section className="hero">
      <div className="hero-bg">
        {HERO_SLIDES.map((src, i) => (
          <div
            key={src}
            className={`hero-slide${i === active ? ' active' : ''}`}
            style={{ backgroundImage: `url('${src}')` }}
          />
        ))}
      </div>
      <div className="hero-veil" />
      <div className="wrap">
        <div className="hero-sub">{t.hero.sub}</div>
        <h1>
          <span className="thin">{t.hero.titleThin}</span> <span className="shine">{t.hero.titleShine}</span>
        </h1>
        <p className="hero-tag">{t.hero.tagline}</p>
        <div className="hero-cta">
          <a className="btn btn-gold" href="#visitar">
            {t.hero.plan}
          </a>
          <a className="btn btn-ghost" href={STORE_URL} target="_blank" rel="noopener">
            {t.hero.store}
          </a>
        </div>
      </div>
    </section>
  );
};
